export default {
  emptyArray: [],
  emptyCharacter: ""
}



// WEBPACK FOOTER //
// ./src/utils/globalVariable.js